var React = require('react');

function CheckBoxSelected (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("rect",{"width":"16","height":"16","fill":"#0088BF","rx":"2","key":0}),React.createElement("path",{"fill":"#FFF","d":"M6.659 9.472l5.657-5.656L13.73 5.23l-5.657 5.657L6.66 12.3 2.416 8.058l1.415-1.414 2.828 2.828z","key":1})]));
}

CheckBoxSelected.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = CheckBoxSelected;

CheckBoxSelected.default = CheckBoxSelected;
